module.exports = __webpack_public_path__ + "img/mat_2.f0a7be59.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1200,"height":894,"variants":[{"file":"img/mat_2-480w.50e5ba29156b.webp","width":480},{"file":"img/mat_2-960w.c7c7e23b38ed.webp","width":960},{"file":"img/mat_2-1200w.69dbb19385b9.webp","width":1200}]};
}